// extracted by mini-css-extract-plugin
export var borderWidth = "java-development-module--border-width--W9I2Z";
export var expandableSectionTitle = "java-development-module--expandable-section-title--djgxv";
export var headerTitleBlueSpan = "java-development-module--header-title-blue-span--avA6B";